'use client';

import React, { useEffect, useMemo } from 'react';
import { useTranslation } from '@/app/features/language/hooks/useTranslation';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle, RotateCcw } from 'lucide-react';

interface ErrorProps {
  error: Error;
  reset: () => void;
}

const ErrorPage: React.FC<ErrorProps> = ({ error, reset }) => {
  const { t } = useTranslation('errors');

  useEffect(() => {
    console.error(error);
  }, [error]);

  // Memoize style object to prevent re-creating on every render
  const containerStyle = useMemo(() => ({ paddingTop: '64px' }), []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 dark:from-gray-900 dark:via-slate-900 dark:to-indigo-950 flex items-center justify-center p-4" style={containerStyle}>
      <Card className="max-w-md w-full p-8 text-center shadow-xl">
        <CardContent className="space-y-6">
          <AlertTriangle className="w-20 h-20 mx-auto text-destructive" />
          <h2 className="text-3xl font-bold text-foreground">
            {t('generic.title')}
          </h2>
          <p className="text-muted-foreground">
            {error.message || t('unknownError')}
          </p>
          <Button
            onClick={() => reset()}
            className="w-full"
            size="lg"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            {t('generic.tryAgain')}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorPage;